import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgApprove = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 18,
	height: 18,
	viewBox: "0 0 18 18",
	fill: "none",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M6.59629 11.906L3.99379 9.30354C3.85367 9.16311 3.66343 9.08418 3.46504 9.08418C3.26666 9.08418 3.07642 9.16311 2.93629 9.30354C2.64379 9.59604 2.64379 10.0685 2.93629 10.361L6.07129 13.496C6.36379 13.7885 6.83629 13.7885 7.12879 13.496L15.0638 5.56104C15.3563 5.26854 15.3563 4.79604 15.0638 4.50354C14.9237 4.3631 14.7334 4.28418 14.535 4.28418C14.3367 4.28418 14.1464 4.3631 14.0063 4.50354L6.59629 11.906Z",
		fill: "currentColor"
	})
});
export default SvgApprove;
